// extracted by mini-css-extract-plugin
export default {"wrapper":"CreateMinerProfile_wrapper__Lnmil","btns":"CreateMinerProfile_btns__vCvro"};